module.exports = __webpack_public_path__ + "img/vertical_4_1_6000.7ddde8e1.png";